export const routeSelection = [
  "id",
  "date",
  "delta",
  "layout",
  "custom",
  "status",
  {
    driver: ["id", "name"],
  },
  {
    truck: [
      "id",
      "title",
      "licence",
      "capacity",
      {
        driver: ["id", "name"],
      },
      "length",
      "width",
    ],
  },
  {
    packingSlips: [
      "id",
      "date",
      "weight",
      "status",
      "pickup_amount",
      "signature",
      "signature_time",
      "comment",
      {
        relation: [
          "id",
          "name",
          "street",
          "house_number",
          "house_number_addition",
          "postal_code",
          "city",
          "phone",
        ],
      },
      {
        requests: [
          "id",
          "type",
          {
            source: [
              "__typename",
              {
                "... on Tire": ["id"],
              },
              {
                "... on Tireset": [
                  "id",
                  "type",
                  {
                    car: ["id", "licence", "label"],
                  },
                ],
              },
            ],
          },
          {
            relation: ["id", "name"],
          },
        ],
      },
    ],
  },
];
